/* ========== COCKPIT MASTER - CUSTOM SCRIPTS ========== */

(function() {
  'use strict';

  // ========== NAVBAR SCROLL EFFECT ==========
  const navbar = document.getElementById('navbar');
  
  window.addEventListener('scroll', () => {
    if (window.scrollY > 80) {
      navbar.classList.add('scrolled');
    } else {
      navbar.classList.remove('scrolled');
    }
  });

  // ========== INTERSECTION OBSERVER - FADE UP ANIMATION ==========
  const observerOptions = {
    threshold: 0.15,
    rootMargin: '0px 0px -80px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Obserwuj wszystkie karty produktów
  document.querySelectorAll('.product-card').forEach((card, index) => {
    card.style.transitionDelay = `${index * 0.1}s`;
    observer.observe(card);
  });

  // ========== FAQ ACCORDION ==========
  const faqQuestions = document.querySelectorAll('.faq-question');

  faqQuestions.forEach(question => {
    question.addEventListener('click', () => {
      const isExpanded = question.getAttribute('aria-expanded') === 'true';
      const answer = question.nextElementSibling;

      // Zamknij wszystkie inne
      faqQuestions.forEach(q => {
        q.setAttribute('aria-expanded', 'false');
        q.nextElementSibling.classList.remove('open');
        q.nextElementSibling.style.maxHeight = '0';
      });

      // Otwórz kliknięty (jeśli był zamknięty)
      if (!isExpanded) {
        question.setAttribute('aria-expanded', 'true');
        answer.classList.add('open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  // ========== ADD TO CART - SHOPIFY AJAX API ==========
  document.querySelectorAll('.add-to-cart').forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const variantId = e.target.getAttribute('data-variant-id');
      
      if (!variantId) {
        console.error('Brak variant ID');
        return;
      }

      // Shopify AJAX Cart Add
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        console.log('Produkt dodany do koszyka:', data);
        
        // Aktualizuj licznik koszyka
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const cartCountElement = document.getElementById('cartCount');
            if (cartCountElement) {
              cartCountElement.textContent = cart.item_count;
            }
          });

        // Visual feedback
        const originalText = e.target.textContent;
        e.target.textContent = 'Dodano!';
        e.target.style.background = '#16a34a';
        e.target.style.borderColor = '#16a34a';
        e.target.disabled = true;
        
        setTimeout(() => {
          e.target.textContent = originalText;
          e.target.style.background = '';
          e.target.style.borderColor = '';
          e.target.disabled = false;
        }, 2000);
      })
      .catch(error => {
        console.error('Błąd dodawania do koszyka:', error);
        alert('Wystąpił problem przy dodawaniu produktu do koszyka. Spróbuj ponownie.');
      });
    });
  });

  // ========== QUICK VIEW (stub - do rozbudowy) ==========
  document.querySelectorAll('.quick-view').forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const productId = e.target.getAttribute('data-product-id');
      console.log('Quick View dla produktu:', productId);
      alert('Funkcja szybkiego podglądu w przygotowaniu');
    });
  });

  // ========== SMOOTH SCROLL ==========
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href === '#') return;
      
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

})();
